<template>
  <div>
    <vs-popup class="holamundo" title="My Events" :active.sync="popup">
      <vs-collapse
        accordion
        :open="true"
        v-for="(merchant, index) in events"
        :key="index"
      >
        <vs-collapse-item>
          <div slot="header">{{ merchant.title }}</div>
          <v-list>
            <vs-list-item
              :title="event.pro_name"
              :subtitle="event.date"
              v-for="(event, index) in merchant.items"
              :key="index"
            >
              <template slot="avatar">
                <img :src="event.poster" class="w-12 mr-3" />
              </template>
              <vs-button color="danger" size="small" @click="goToE(event)"
                >View</vs-button
              >
            </vs-list-item>
          </v-list>
        </vs-collapse-item>
      </vs-collapse>

      <!--
        <vs-list-header title="Active" color="danger"></vs-list-header>
        <vs-list-item
          :title="item.pro_name"
          :subtitle="item.date"
          v-for="(item, index) in events"
          :key="index"
        >
          <template slot="avatar">
            <img :src="item.poster" class="w-12 mr-3" />
          </template>
          <vs-button color="danger" size="small" @click="goToE(item)">View</vs-button>
        </vs-list-item>
      </vs-list>
      -->
    </vs-popup>
  </div>
</template>
<script>
import { mapState } from "vuex";

export default {
  components: {},
  name: "event-list-popup",
  props: {
    visible: false,
    list: null
  },
  computed: {
    popup: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit("close");
        } else {
        }
      }
    }
    /*
    ...mapState({
      list: state => {
        //return state.Event.list;
        return [];
      }
    })
    */
  },
  data: () => ({
    events: []
  }),
  watch: {
    list() {
      if (this.list != null) {
        var groups = this.list.reduce(function(obj, item) {
          obj[item.merchant.s] = obj[item.merchant.s] || [];
          //item["quantity"] = 0;
          obj[item.merchant.s].push({
            ...item
          });
          return obj;
        }, {});
        var myArray = Object;
        myArray = Object.keys(groups).map(key => {
          let event = groups[key];
          return {
            title: event[0].merchant.name,
            s: event[0].merchant.s,
            items: event
          };
        });
        this.events = myArray;
      } else {
        this.events = [];
      }
    }
  },
  created() {},
  methods: {
    goToE(item) {
      let s = item.merchant.s;
      let e = item.e;

      let header = {
        slug: item.slug,
        title: item.pro_name,
        excerpt: item.date,
        image: item.merchant.logo,
        action: "openEventList"
      };

      this.$store.dispatch("Utility/setMerchant", s).then(res => {
        this.$store.dispatch("Utility/setEvent", e).then(res => {
          this.$store.dispatch("Utility/setHeader", header);
          window.location.href = this.$route.path + "?s=" + s + "&e=" + e;
        });
      });

      /*
      this.$router
        .push({
          path: "/orders",
          query: { s: folder, e: e }
        })
        .catch(err => {});
        */
    },
    groupBy(list, keyGetter) {
      const map = new Map();
      list.forEach(item => {
        const key = keyGetter(item);
        const collection = map.get(key);
        if (!collection) {
          map.set(key, [item]);
        } else {
          collection.push(item);
        }
      });
      return map;
    }
  }
};
</script>
